export function getSecureRandomNumber() {
  const randomBytes = new Uint32Array(1);
  window?.crypto?.getRandomValues(randomBytes);
  return randomBytes[0] / (2 ** 32 - 1) || 1;
}
